import * as Yup from "yup";
import moment from "moment";
import { useState, useEffect, useLayoutEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import {
  API_URL,
  ROUTES,
  STOOL_RECORD_COLOR_OPTIONS,
  STOOL_RECORD_QUALITY_OPTIONS,
  STOOL_RECORD_QUANTITY_OPTIONS,
  STOOL_RECORD_FREQUENCY_OPTIONS,
} from "../../../../constants";
import { useFormikContext, FieldArray } from "formik";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { FormikDialog } from "../../../../components/dialogs";
import FormikDateTimeField from "../../../../components/inputs/FormikDateTimeField";
import FormikSelectField from "../../../../components/inputs/FormikSelectField";
import FormikTextField from "../../../../components/inputs/FormikTextField";
import FormikReferenceField from "../../../../components/inputs/FormikReferenceField";
import axios from "axios";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import FormLabel from "@material-ui/core/FormLabel";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

export const initialValues = {
  recordDateTime: moment.utc(new Date()).toISOString(),
  color: "",
  quality: "",
  quantity: "",
  frequency: "",
  remarks: "",
  status: "",
};

export const validationSchema = Yup.object().shape({
  recordDateTime: Yup.string()
    .required(<FormattedMessage id="validation.message.required" />)
    .typeError(<FormattedMessage id="validation.message.invalidDateFormat" />)
    .nullable(),
  color: Yup.string()
    .required(<FormattedMessage id="validation.message.required" />)
    .nullable(),
  quality: Yup.string()
    .required(<FormattedMessage id="validation.message.required" />)
    .nullable(),
  quantity: Yup.string()
    .required(<FormattedMessage id="validation.message.required" />)
    .nullable(),
  frequency: Yup.string()
    .required(<FormattedMessage id="validation.message.required" />)
    .nullable(),
});

export function EditDialog(props) {
  const { open, entity, onClose, onSubmit, apiUrl } =
    props;
  const [entityValues, setEntityValues] = useState();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (entity) {
      axios
        .get((apiUrl.getOne ? apiUrl.getOne : apiUrl) + "/" + entity.id)
        .then((response) => {
          let data = response?.data;
          let entityValues = { ...initialValues, ...data };

          entityValues.recordDateTime = moment
            .utc(data.recordDateTime)
            .toISOString();
          setEntityValues(entityValues);
        })
        .catch((error) => {})
        .finally(() => {
          setLoaded(true);
        });
    } else {
      setEntityValues(initialValues);
    }
  }, [entity]);

  return (
    <FormikDialog
      open={open}
      dialogTitle={"修改大便記錄"}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      onClose={onClose}
      maxWidth="md"
    >
      <EditForm entity={entityValues} />
    </FormikDialog>
  );
}

const EditForm = (props) => {
  const home = useSelector((state) => state.home);
  const { entity, apiUrl = "" } = props;
  const [beds, setBeds] = useState([]);
  const [detailEntity, setDetailEntity] = useState({});
  const [loaded, setLoaded] = useState(false);
  const { initialValues, values, touched, errors, setFieldValue, resetForm } =
    useFormikContext();

  useLayoutEffect(() => {
    resetForm({ values: initialValues });
    if (entity) {
      resetForm({ values: { ...initialValues, ...entity } });
    } else {
      resetForm({ values: initialValues });
    }
  }, [entity]);

  useEffect(() => {}, []);

  return (
    <form>
      <Grid container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Card variant="outlined" style={{ marginBottom: 15 }}>
            <CardContent>
              <Typography
                variant="h6"
                gutterBottom
                style={{ marginBottom: 15 }}
              >
                膳食記錄資料
              </Typography>
              <Grid container spacing={2}>
                <Grid item sm={12} xs={12}>
                  <FormikDateTimeField
                    required
                    label="膳食記錄日期及時間"
                    name="recordDateTime"
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <FormikSelectField
                    required
                    label="顏色"
                    name="color"
                    options={STOOL_RECORD_COLOR_OPTIONS}
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <FormikSelectField
                    required
                    label="素質"
                    name="quality"
                    options={STOOL_RECORD_QUALITY_OPTIONS}
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <FormikSelectField
                    required
                    label="數量"
                    name="quantity"
                    options={STOOL_RECORD_QUANTITY_OPTIONS}
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <FormikSelectField
                    required
                    label="頻率"
                    name="frequency"
                    options={STOOL_RECORD_FREQUENCY_OPTIONS}
                  />
                </Grid>

                <Grid item sm={12} xs={12}>
                  <FormikTextField label="備註" name="remarks" />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </form>
  );
};
